module.exports = __webpack_public_path__ + "img/t1-petition.e29a9b3c.png";